<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      Manage Card
    </Teleport>

    <button
      v-if="!isCreditCard"
      class="cf-button cf-button--secondary cf-button--lg cf-button--fill"
      type="button"
      @click="$openModal('giftCardPurchase', { cardToReload: paymentMethod, overrideReceiptNavigation: true })"
    >
      Add Funds
    </button>

    <button
      v-if="isAbleToMerge"
      class="cf-button cf-button--secondary cf-button--lg cf-button--fill"
      type="button"
      @click="$openModal('giftCardMerge', { cardId: paymentMethod.cardId })"
    >
      Merge Card
    </button>

    <button
      v-if="!isCreditCard"
      class="cf-button cf-button--danger-alt cf-button--lg cf-button--fill"
      type="button"
      :disabled="!isAbleToRemove"
      @click="deleteGiftCard"
    >
      Delete Card
    </button>

    <button
      v-if="isCreditCard"
      class="cf-button cf-button--danger-alt cf-button--lg cf-button--fill"
      type="button"
      @click="deleteCreditCard"
    >
      Delete Card
    </button>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'CardScanManagement',

    props: {
      paymentMethod: {
        type: Object,
        required: true
      }
    },

    computed: {
      ...mapGetters('giftCards', ['giftCards']),
      ...mapGetters('merchant', ['merchant']),

      isCreditCard() {
        return !!this.paymentMethod.creditCardId;
      },

      isAbleToRemove() {
        return this.paymentMethod.amount === 0 || !this.paymentMethod.isVirtual;
      },

      isAbleToMerge() {
        const cardCountWithValue = this.giftCards.savedCards.filter(card => card.amount > 0);

        return !this.isCreditCard && cardCountWithValue.length > 1 && this.paymentMethod.amount > 0 && this.merchant.giftCardConfiguration?.allowBalanceMerge;
      }
    },

    methods: {
      deleteGiftCard() {
        this.$openModal('confirmation', {
          ctaConfirmText: 'Yes, Remove',
          hideSecondaryCta: true,
          primaryText: 'You are about to remove this gift card from your account.',
          onConfirm: () => this.$store.dispatch('giftCards/removeCard', this.paymentMethod),
          title: 'Remove gift card?'
        });
      },

      deleteCreditCard() {
        const confirmationModalConfig = {
          ctaConfirmText: 'Confirm',
          title: 'Delete Saved Card',
          hideSecondaryCta: true,
          onConfirm: async () => {
            await this.$store.dispatch('savedCards/deleteCard', this.paymentMethod.creditCardId);

            // this.$triggerGoogleTrackingEvent('RemoveCreditCard', 'Account');

            this.$triggerNewRelicEvent('RemoveCreditCard', 'Information', 'Removed Saved Credit Card');
          }
        };

        const confirmationMessage = 'Are you sure you want to delete this saved card?';

        const warningMessage = `The card ending in <b>${this.paymentMethod.displayText}</b> is being utilized as an auto-reload payment method. Deleting this card will disable auto-reload settings for configured gift cards.`;

        if (this.paymentMethod.isUsedToAutoReloadGiftCard) {
          Object.assign(confirmationModalConfig, { primaryText: warningMessage, secondaryText: confirmationMessage });
        }
        else {
          Object.assign(confirmationModalConfig, { primaryText: `Are you sure you want to delete the saved card ending in <b>${this.paymentMethod.displayText}</b>?` });
        }

        this.$openModal('confirmation', confirmationModalConfig);
      }
    }
  };
</script>

